import { General } from "../../../../siteManagement/general.js";
import { SheetEventType } from "../../../../siteManagement/sheet.js";
import { AppHelper } from "../../../appHelper.js";
import { Config } from "../../config/config.js";
import { Helper } from "../../util/helper.js";
import { AppBaseProps, CommonApp, Entity } from "../commonApp.js";
import { FullHeightContainer } from "../FullHeighContainer.js";
import { BaseColumn, ComponentColumn, MultiColumn } from "./editableGrid.js";
import GridDetails from "./gridDetails.js";
import React from "react";
interface EditInGridRowEntity extends Entity {
    dataItem: any;
    gridOptions?: kendo.ui.GridOptions;

}

export interface EditInGridRowProps extends AppBaseProps {
    entity: EditInGridRowEntity;
    id: string;
}

export class EditInGridRow extends React.Component<EditInGridRowProps, any>{
    private common = new AppHelper();

    constructor(props: any) {
        super(props);
        this.common.init(this);
    }

    componentDidMount() {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command == "onDataChanged") {
                this.common.setEntityDirtyState(true);
            }
        })
    }

    save = () => {
        this.common.handlePostSave(true, true);
    }

    renderDetails = () => {
        return <GridDetails
            columns={this.props.entity.gridOptions.columns}
            dataItem={this.props.entity.dataItem}
            editable={this.props.entity.RecordRight.CanWrite}
            id={this.props.id}
            onTemplateClick={() => { }}
            visible={true}
            isSheet={true}
        />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: () => { } });
        return (<>
            <CommonApp {...props} />
        </>);
    }
}

export const getEditInGridMetaData = (columns: BaseColumn[], dataItem: any, withGeneralFields: boolean, helpEditUrl: string = "") => {
    const getComponentColumnsRecursiv = (baseColumns: BaseColumn[]): ComponentColumn[] => {
        let componentColumns: ComponentColumn[] = [];
        for (let column of baseColumns) {
            if (column instanceof ComponentColumn)
                componentColumns.push(column);
            if (column instanceof MultiColumn) {
                let columns = getComponentColumnsRecursiv(column.columns);
                componentColumns.push(...columns);
            }
        }
        return componentColumns;
    }
    

    let componentColumns: ComponentColumn[] = getComponentColumnsRecursiv(columns);
    let tabs: any[] = [{
        title: Helper.getTranslation("Server.Allgemein"),
        visible: withGeneralFields,
        iconName: "folder-open",
        regions: [{
            title: Helper.getTranslation("Server.Allgemein"),
            renderHeader: false,
            size: [
                {
                    container: "extrasmall",
                    width: "12/12"
                },
                {
                    container: "small",
                    width: "12/12"
                },
                {
                    container: "medium",
                    width: "12/12"
                },
                {
                    container: "large",
                    width: "12/12"
                },
                {
                    container: "extralarge",
                    width: "12/12"
                }
            ],
            fields: [
                {
                    labelAndControlCombined: true,
                    name: "general",
                    readOnly: false,
                    required: false,
                    visible: withGeneralFields,
                    type: "dynamic",
                    componentName: "renderDetails()",
                    helpUrl: helpEditUrl
                }
            ]
        }]
    }];

    for (let componentColumn of componentColumns) {
        let props = componentColumn.props(dataItem); 

        let tab = {
            title: componentColumn.title,
            iconName: componentColumn.iconName,
            moduleName: componentColumn.moduleName,
            visible: componentColumn.visible(dataItem) && (props.visible ?? true),
            helpUrl: componentColumn.helpUrl,
            props: props
        }
        tabs.push(tab);
    }

    return {
        tabs: tabs,
        pageTitle: Helper.getTranslation("Standard.Bearbeiten"),
        menuDataSource: [{
            type: "save",
            floating: !Config.settings.isMobileApp && !Helper.useMobileGui(),
            floatingColor: "#cc3467"
        }
        ],
        additional: {
            objects: []
        },
        rightDrawerContainer: {
            visible: true,
            width: 400,
            multipleComponents: [
                {
                    iconName: "question-circle",
                    iskey: "RIGHTDRAWER_COMPONENT_IFRAME",
                    moduleName: "app/core/components/iframe",
                    props: {
                        url: helpEditUrl
                    },
                    renderAlways: true,
                    type: "rightdrawer_help",
                }
            ]
        }    };
}